var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-box"},_vm._l((_vm.nav_list),function(item){return _c('div',{key:item.url,staticClass:"nav-item",on:{"click":function($event){return _vm.navigatorAction(item)}}},[_c('span',[_vm._v(_vm._s(item.title))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }